import { Card } from "antd";
import { Container } from "../../../components/Container";
import { getImageUrl } from "../../../utils/image";
import React from "react";
import "./index.scss";
export var About = function About() {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Title, null)));
};

var Title = function Title() {
  return /*#__PURE__*/React.createElement("div", {
    className: "title-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "header-overview",
    src: getImageUrl("header-overview.png")
  }), /*#__PURE__*/React.createElement("div", {
    className: "title-description"
  }, "If you want to sell NFTs but don\u2019t want to build an entire NFT marketplace from scratch, then NFT Maker is the plugin you\u2019ve been waiting for.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Lazy Minting. Free IPFS Storage, forever. Supports Ethereum, Polygon, Binance Smart Chain, Celo, and Harmony.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "NFT Maker by Tatum allows you to turn your Woocommerce store into an NFT store with a simple plugin. Install our plugin, follow your usual WordPress product publishing flow, and just tick which blockchain you\u2019d like to mint your NFTs on."));
};